import { Injectable } from '@angular/core';
import { QuickCalculationCacheModel } from '../models/quick-calculation-cache.model';
import { DataMapper } from '@pristine-ts/data-mapping-common';
import { CalculationKeynameEnum } from '../../../../../../../common/src/enums/calculations/calculation-keyname.enum';

@Injectable()
export class QuickCalculationManager {

  constructor(private readonly dataMapper: DataMapper) {
  }

  async list(): Promise<QuickCalculationCacheModel[]> {
    const cache = await caches.open('quick-calculations');

    const keys = await cache.keys();

    const quickCalculations: QuickCalculationCacheModel[] = [];
    for (const key of keys) {
      const quickCalculation = await cache.match(key);
      const quickCalculationModel = await quickCalculation.json();
      quickCalculations.push(await this.dataMapper.autoMap(quickCalculationModel, QuickCalculationCacheModel));
    }

    return quickCalculations.sort((a, b) => b.updatedAt.getTime() - a.updatedAt.getTime());
  }

  async save(type: CalculationKeynameEnum, title: string, options: any, results?: any, id?: string): Promise<void> {
    const quickCalculationCacheModel = new QuickCalculationCacheModel();
    quickCalculationCacheModel.id = id ?? quickCalculationCacheModel.id;
    quickCalculationCacheModel.type = type;
    quickCalculationCacheModel.title = title;
    quickCalculationCacheModel.options = options;
    quickCalculationCacheModel.results = results;
    quickCalculationCacheModel.updatedAt = new Date();

    const cache = await caches.open('quick-calculations');
    await cache.put(quickCalculationCacheModel.id, new Response(JSON.stringify(quickCalculationCacheModel)));
  }
}
